import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { withVar } from "themes/helpers";

const Container = styled.div`
  position: relative;

  label {
    display: inline-block;
    margin: 0 5px 6px;
    font-size: 14px;
    line-height: 17px;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.primaryColor80
    };
  }

  > span,
  > div {
    display: block;

    input[type="text"],
    input[type="password"] {
      width: 100%;
    }

    textarea {
      width: 100%;
    }
  }

  .locked-icon {
    position: absolute;
    top: 34px;
    right: 10px;

    svg {
      fill: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.primaryColor60
      };
    }
  }

  .validation-error {
    padding: 3px 0 0 10px;
    color: ${withVar(DesignToken.ContentBasicNegative)};
    font-size: 14px;
    line-height: 17px;
  }
`;

interface IProps {
  label?: React.ReactNode;
  disabled?: boolean;
  error?: string;
  children: React.ReactNode;
}

export const FormControl: React.FC<IProps> = ({ label, disabled, error, children }) => (
  <Container>
    {!!label && <label>{label}</label>}
    {children}
    {error && <div className="validation-error">{error}</div>}
    {disabled && (
      <span className="locked-icon">
        <Icon name={IconsEnum.ClosedLock} width="16px" height="16px" />
      </span>
    )}
  </Container>
);
